import { all, takeEvery } from 'redux-saga/effects'

import { SubscriptionActions } from '../actions'
import { braintreeCancel } from './braintreeCancel'
import { downloadInvoice } from './downloadInvoice'
import { fetchSubscription } from './fetchSubscription'
import { requestBillingPortal } from './requestBillingPortal'

export function* subscriptionSaga() {
  yield all([
    takeEvery(SubscriptionActions.fetch, fetchSubscription),
    takeEvery(SubscriptionActions.braintreeCancel, braintreeCancel),
    takeEvery(SubscriptionActions.downloadInvoice, downloadInvoice),
    takeEvery(SubscriptionActions.requestBillingPortal, requestBillingPortal),
  ])
}
